function Communication (name, params) {
  console.log('appFunction:' + name, params)
  if (!window.flutter_inappwebview) return
  window.flutter_inappwebview.callHandler(name, params)
}
window.Communication = Communication
